import { render, staticRenderFns } from "./UnpaginatedTable.vue?vue&type=template&id=f25512ae"
import script from "./UnpaginatedTable.vue?vue&type=script&lang=js"
export * from "./UnpaginatedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports